import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SubmitItineraryErrorConstants } from '@uzurv/rideWss/app/constants';
import { LocationErrorConstants, PaymentAccountErrorConstants, RideErrorConstants } from '@uzurv/rideWss/clara';

@Injectable({
  providedIn: 'root'
})
export class ErrorTranslationService {
  constructor(private translateService: TranslateService) {}

  translateErrorMessage(errorMessage: string): string {
    if (LocationErrorConstants.IMPRECISE_LOCATION.test(errorMessage)) {
      return this.translateService.instant('favoriteLocationDetail.error.impreciseLocation');
    } else if (LocationErrorConstants.LOCATION_NOT_FOUND.test(errorMessage)) {
      return this.translateService.instant('favoriteLocationDetail.error.locationNotFound');
    } else if (LocationErrorConstants.LOOKUP_ERROR.test(errorMessage)) {
      return this.translateService.instant('favoriteLocationDetail.error.lookup');
    } else if (RideErrorConstants.OVERLAPPING_RIDE_REQUEST.test(errorMessage)) {
      return this.translateService.instant('ride.error.message.overlappingRideRequest');
    } else if (RideErrorConstants.PICKUP_AND_DROPOFF_MATCH.test(errorMessage)) {
      return this.translateService.instant('ride.error.message.pickupAndDropoffMatch');
    } else if (RideErrorConstants.PICKUP_DATE_OUTSIDE_OF_OPERATING_HOURS.test(errorMessage)) {
      return this.translateService.instant('ride.error.message.pickupDateOutsideOfOperatingHours');
    } else if (RideErrorConstants.LOCATION_NOT_WITHIN_GEOFENCE.test(errorMessage)) {
      return this.translateService.instant('ride.error.message.locationNotWithinGeofence');
    } else if (RideErrorConstants.PICKUP_DATE_IS_IN_PAST.test(errorMessage)) {
      return this.translateService.instant('ride.error.message.pickupDateMustBeInFuture');
    } else if (PaymentAccountErrorConstants.CREDIT_CARD_EXPIRATION_IS_PAST.test(errorMessage)) {
      return this.translateService.instant('paymentAccount.error.message.creditCardExpired');
    } else if (SubmitItineraryErrorConstants.RIDE_LIMIT_REACHED_WITH_RIDE_TYPE.test(errorMessage)) {
      const regexResult = SubmitItineraryErrorConstants.RIDE_LIMIT_REACHED_WITH_RIDE_TYPE.exec(errorMessage);
      const rideType: string = regexResult[1].toLowerCase();
      const period: string = regexResult[2].toLowerCase();
      return this.translateService.instant('createRideOptionsOptions.alert.message.rideLimitReachedWithRideType', {
        rideType: rideType,
        period: period
      });
    } else if (SubmitItineraryErrorConstants.RIDE_LIMIT_REACHED.test(errorMessage)) {
      const regexResult = SubmitItineraryErrorConstants.RIDE_LIMIT_REACHED.exec(errorMessage);
      const period: string = regexResult[1].toLowerCase();
      return this.translateService.instant('createRideOptionsOptions.alert.message.rideLimitReached', {
        period: period
      });
    }
    return errorMessage;
  }
}
